import { FaFacebookF, FaInstagram, FaYoutube, FaTwitter } from "react-icons/fa";

export const footerLinks = [
  {
    id: 1,
    title: "About Us",
    linkOne: "story",
    linkTwo: "clients",
    linkThree: "testimonials",
    linkFour: "",
  },
  {
    id: 2,
    title: "Services",
    linkOne: "rooms",
    linkTwo: "activities",
    linkThree: "nature",
    linkFour: "attractions",
  },
  {
    id: 3,
    title: "Contact Us",
    linkOne: "United Kingdom",
    linkTwo: "United States",
    linkThree: "Thailand",
    linkFour: "South Africa",
  },
];

export const social = [
  {
    icon: <FaFacebookF />,
    name: "Facebook",
  },
  {
    icon: <FaInstagram />,
    name: "Instagram",
  },
  {
    icon: <FaYoutube />,
    name: "Youtube",
  },
  {
    icon: <FaTwitter />,
    name: "Twitter",
  },
];
